import {
  defaultEnvironment,
  residentAppsProductionCustomerIndents
} from './environment.defaults';

export const environment = {
  ...defaultEnvironment,
  ...residentAppsProductionCustomerIndents,

  production: true,
  development: false,
  deploymentEnv: 'production',
  file_upload_path: 'https://gql-ll.immomio.com/ll/fileUpload',
  graphql_server_uri: 'https://gql-ll.immomio.com/graphql',
  graphql_resident_server_uri: 'https://api-rs.immomio.com/graphql',
  graphql_host: 'https://gql-ll.immomio.com',
  backend_url: 'https://api-ll.immomio.com/ll',
  backend_tunnel_url: 'https://api-ll.immomio.com/ll/graphql',
  filer_url: 'https://filer-ll.immomio.com',
  ftp_url: 'ftp.immomio.com',

  landlord_app_url: 'https://app.immomio.com',
  landlord_home_url: 'https://www.vermieter.immomio.com',
  keycloakConfig: {
    ...defaultEnvironment.keycloakConfig,

    realm: 'immomio-ll',
    'auth-server-url': 'https://sso.immomio.com/auth/'
  },
  tileServerUrl:
    'https://tiles.geo.immomio.com/styles/basic-preview/{z}/{x}/{y}.png'
};
